import { IKeyboardShortcutHandler } from '@/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service-interface';
import { IModalManagerService } from '@/app-modules/modal-manager/modal-manager-service';
import { ModalManagerPlugin, IModal } from '@/plugins/modal-manager';
import { container } from '@/app-modules/_ioc';
import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

export const ChatFreezeKeyboardShortcutEventHandlerName = 'chatFreezeEvent';

class KeyboardShortcutHandlerToggleChatFreeze implements IKeyboardShortcutHandler {
  private readonly keyboardCode: number = 32;

  public canProcessKeyboardEvent(keyboardEvent: KeyboardEvent): boolean {
    return (keyboardEvent.ctrlKey && keyboardEvent.keyCode === this.keyboardCode) || keyboardEvent.key === 'Escape';
  }

  public processKeyboardEvent(keyboardEvent: KeyboardEvent): void {
    if (this.canProcessKeyboardEvent(keyboardEvent)) {
      const modalManagerService: ModalManagerPlugin = this.getModalManagerService().getModalManager();

      const activeModal: IModal = modalManagerService.getActiveModal();

      if (activeModal) {
        this.getEventBusService().getEventBus().$emit(ChatFreezeKeyboardShortcutEventHandlerName, activeModal.modalGuid);
      }
    }
  }

  private getModalManagerService(): IModalManagerService {
    return container.get(SERVICE_IDENTIFIERS.IModalManagerService);
  }

  private getEventBusService(): IEventBusService {
    return container.get(SERVICE_IDENTIFIERS.IEventBusService);
  }
}

export { KeyboardShortcutHandlerToggleChatFreeze };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/keyboard-shortcut-service/handlers/toggle-chat-freeze.ts